import { render } from "./gbv.html?vue&type=template&id=3519a249&external"
import script from "./gbv.js?vue&type=script&lang=js&external"
export * from "./gbv.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__